import { render, staticRenderFns } from "./DbpyPD_ReceiveList.vue?vue&type=template&id=4dc1c723"
import script from "./DbpyPD_ReceiveList.vue?vue&type=script&lang=js"
export * from "./DbpyPD_ReceiveList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports